module.exports = __webpack_public_path__ + "assets/0294b937e2a01c1fd30569c22cd54f17.mp3";